/**
 * Web メルカトルのタイル座標計算 (純関数)。
 *
 * ベクタタイルの HTTP 直取得 (services/mapbox-road-tiles.ts) 用。WebGL プローブの
 * querySourceFeatures と違い、タイル座標さえ分かれば描画なしで取得できる。
 */

/** lng/lat を zoom のタイル座標 (整数) へ。 */
export function lngLatToTile(
  lng: number,
  lat: number,
  z: number,
): { x: number; y: number } {
  const n = 2 ** z;
  const x = Math.floor(((lng + 180) / 360) * n);
  const latRad = (lat * Math.PI) / 180;
  const y = Math.floor(
    ((1 - Math.asinh(Math.tan(latRad)) / Math.PI) / 2) * n,
  );
  const clamp = (v: number) => Math.max(0, Math.min(n - 1, v));
  return { x: clamp(x), y: clamp(y) };
}

/** bbox [w,s,e,n] を padM (m) だけ広げる。 */
export function padBbox(
  bbox: [number, number, number, number],
  padM: number,
): [number, number, number, number] {
  const [w, s, e, n] = bbox;
  const midLat = (s + n) / 2;
  const kx = Math.max(Math.cos((midLat * Math.PI) / 180), 0.2) * 111_320;
  const dLng = padM / kx;
  const dLat = padM / 110_540;
  return [w - dLng, s - dLat, e + dLng, n + dLat];
}

/** bbox を覆う zoom のタイル一覧 (行優先)。 */
export function tilesCoveringBbox(
  bbox: [number, number, number, number],
  z: number,
): Array<{ x: number; y: number }> {
  const [w, s, e, n] = bbox;
  const tl = lngLatToTile(w, n, z); // 北西
  const br = lngLatToTile(e, s, z); // 南東
  const out: Array<{ x: number; y: number }> = [];
  for (let y = tl.y; y <= br.y; y++) {
    for (let x = tl.x; x <= br.x; x++) {
      out.push({ x, y });
    }
  }
  return out;
}
